<template>
  <div class="content-card">
    <div
      v-if="memory.vimeo_id || memory.preview_urls"
      class="content-card__side content-card__side-preview"
    >
      <div :style="sideStyles" class="content-card__side-preview-bg"></div>
      <v-responsive class="content-card__video" :aspect-ratio="480 / 280">
        <VimeoPlayer v-if="memory.vimeo_id" :vimeoId="memory.vimeo_id" />
        <img
          width="100%"
          v-else-if="memory.preview_urls"
          :src="memory.preview_urls.large"
        />
      </v-responsive>
    </div>
    <div class="content-card__side content-card__side--scroll">
      <div class="content-card__user" v-if="memory.last_name">
        By {{ memory.full_name }}
      </div>
      <div
        class="content-card__title"
        :class="{ fill_in_blank: memory.last_name }"
      >
        <span class="content-card__user" v-if="memory.last_name">{{
          memory.last_name
        }}</span>
        <div>
          <span>
            {{ memory.moment_to }}
          </span>
        </div>
      </div>
      <div class="content-card__description">{{ memory.description }}</div>
      <v-btn
        rounded
        outlined
        color="#C4C4C4"
        v-if="memory.content_link_type == 'download_reference'"
        :href="memory.content_link || memory.preview_urls.original"
        target="_blank"
      >
        <span style="margin-right: 5px">{{
          memory.content_link_text || "download"
        }}</span>
        <v-icon style="top: 2px" color="#C4C4C4" size="16">$download</v-icon>
      </v-btn>
      <v-btn
        large
        color="primary"
        v-else-if="memory.content_link_type == 'button' && memory.content_link"
        :href="memory.content_link || memory.preview_urls.original"
        target="_blank"
      >
        {{ memory.content_link_text || "open" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Memory",
  props: {
    memory: Object,
    color: String,
  },
  computed: {
    sideStyles() {
      return {
        backgroundColor: "white",
      };
    },
  },
};
</script>

<style scoped lang="scss">
.content-card__description {
  white-space: break-spaces;
  margin: 20px 0;
}
.content-card {
  &__title,
  &__user {
    font-family: "Roboto Condensed";
    font-weight: 700;
  }
}
</style>
